import { styled } from "@mui/system";
import { Menu, MenuItem, IconButton } from "@mui/material";

export const StyledMenu = styled(Menu)(({ theme }) => ({
  "& .MuiPaper-root": {
    display: "flex",
    flexDirection: "row",
    padding: 0,
    shadows:theme.shadows.main,
    border: `1px solid ${theme.palette.grey.light}`,
  },
}));

export const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
    display: "inline-block",
    padding: theme.spacing(0.5, 1),
    transition: "background-color 0.3s",
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
}));

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
    padding: theme.spacing(0),
}));

export const StyledMeatballsButton = styled(IconButton)(({ theme }) => ({
    color: theme.palette.secondary.main,
    backgroundColor: theme.palette.blue.light,
    padding: theme.spacing(0.5),
    margin: theme.spacing(0, 1),
}));
